module.exports = __webpack_public_path__ + "img/12.46e36f1e.png";